__turbopack_context__.v({
  "cinemaList": "_jAXMW_cinemaList",
  "noResults": "_jAXMW_noResults",
  "searchButton": "_jAXMW_searchButton",
  "searchInput": "_jAXMW_searchInput",
  "searchWrapper": "_jAXMW_searchWrapper",
  "showMoreButton": "_jAXMW_showMoreButton",
});
